import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import DataHelper, { DataHelperConfiguration } from "@Scripts/Common/DataHelper";
import FormHelper from "@Scripts/Common/FormHelper";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

@Component({ name: "MaintenancePackageEstimateRequest" })
export default class MaintenancePackageEstimateRequest extends Vue {
    public dataConfiguration: DataHelperConfiguration = { culture: "it-IT" };
    public isLoading: boolean = true;
    public isLoadingForm: boolean = false;
    public isSuccess: boolean = false;
    public formData: any = { model: null, durationYears: null, durationKm: null, zone: null, dealerPointCode: null, isProfiling: false, isMarketing: false, marketingChannels: [] };
    public models: any[] = [];
    public packages: any[] = [];
    public durationKms: any[] = [];
    public packageDetail: any = null;
    public zones: any[] = [];
    public dealerPoints: any[] = [];
    public formDealerPoints: any[] = [];
    public validationErrors: any[] = [];

    @Prop() readonly recaptchaSiteKey: string;
    @Prop() readonly dealerCode: string;
    @Prop() readonly isDealerSite: boolean;

    get routes() {
        return (<any>window).App.routes;
    }

    get selectedDealerPointCode() {
        return this.$store.getters["dealerStore/selectedDealerPointCode"];
    }

    public async created() {
        await this.getData();
    }

    public async getData() {
        this.isLoading = true;

        const response = (await Axios.post(this.routes.MaintenancePackage_EstimateRequest_GetData)).data;
        this.models = response.models;
        this.isLoading = false;
    }

    public async changeModel() {
        this.formData.durationYears = null;
        this.formData.durationKm = null;

        const response = (await Axios.post(this.routes.MaintenancePackage_EstimateRequest_GetPackages, this.formData)).data;
        this.packages = response.packages;
    }

    public changeDurationYears() {
        this.durationKms = this.packages.filter(x => x.durationYears === this.formData.durationYears)[0].durationKm;
        this.formData.durationKm = null;
    }

    public async calculateEstimate() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoadingForm = true;
        this.formData.dealerCode = this.dealerCode != null ? this.dealerCode : null;

        try {
            const response = (await Axios.post(this.routes.MaintenancePackage_EstimateRequest_GetPackageData, this.formData)).data;
            this.packageDetail = response.package;
            this.zones = response.zones;
            this.dealerPoints = response.dealerPoints;

            if (this.dealerCode != null) {
                this.formDealerPoints = this.dealerPoints;
            }

            if (this.dealerPoints.length === 1) {
                this.formData.dealerPointCode = this.dealerPoints[0].code;
            } else if (this.isDealerSite) {
                this.formData.dealerPointCode = this.selectedDealerPointCode;
            }

            document.querySelector("#EstimateDescription").classList.add("hden");
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoadingForm = false;

        document.querySelector(".app-page").scrollIntoView();
    }

    public async changeSelectedZone() {
        this.formData.dealerPointCode = null;
        this.formDealerPoints = [];

        if (this.formData.zone) {
            this.formDealerPoints = this.dealerPoints.filter(x => x.province === this.formData.zone);
        }
    }

    public async submitForm() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoadingForm = true;

        this.formData.origin = this.isDealerSite ? "DealerSite" : "YMITSite";

        (<any>window).grecaptcha.enterprise.ready(async () => {
            const token = await (<any>window).grecaptcha.enterprise.execute(this.recaptchaSiteKey, { action: 'Submit' });

            try {
                await Axios.post(this.routes.MaintenancePackage_EstimateRequest_Save, this.formData, { headers: { "RecaptchaVerificationToken": token } });
                this.isSuccess = true;

                GTagHelper.sendEvent("form_submit", "maintenance_quote");
            } catch (error) {
                if (error.response && error.response.status === 400) {
                    this.validationErrors = FormHelper.getValidationErrors(error.response.data);
                }
            }

            this.isLoadingForm = false;
        });
    }

    public reload() {
        location.reload();
    }

    public profiling(profiling: boolean) {
        this.formData.isProfiling = profiling;
    }

    public marketing(marketing: boolean) {
        this.formData.isMarketing = marketing;
    }

    public marketingChannels(marketingChannels: any) {
        this.formData.marketingChannels = marketingChannels;
    }

    public isValidationError(controlName: string): boolean {
        return FormHelper.isControlValidationError(controlName, this.validationErrors);
    }

    public formatNumber(data: number): string {
        return DataHelper.convertNumberToString(data, this.dataConfiguration, false);
    }

    public formatPrice(price: number): string {
        let configuration = this.dataConfiguration;
        configuration.decimalCount = 2;
        return DataHelper.convertToString(price, "Decimal", configuration);
    }
};